import { Icon, useTheme } from '@/design-system';
import styles from './ThemeToggle.module.css';

/** The same control as the upstream site header, so it reads the same everywhere. */
export function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();
  return (
    <button
      type="button"
      className={styles.toggle}
      onClick={toggleTheme}
      aria-label={theme === 'light' ? 'Switch to dark theme' : 'Switch to light theme'}
    >
      <Icon name={theme === 'light' ? 'moon' : 'sun'} size={17} />
    </button>
  );
}
